module.exports = {"id":"158856","name":"Christian Gentner","rating":"78","photo":"./data/images/photos/2/158856.png","club":{"name":"VfB Stuttgart","logo":"./data/images/clubs/VfBStuttgart.png"},"positions":["MC","MDC","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChristianGentner0.json
// module id = 790
// module chunks = 0